import gql from 'graphql-tag';

export default gql`
  {
    getThePlace {
      id
      img_header_desktop
      img_header_mobile
      img_bg_desktop
      img_bg_mobile
      img_visual_top_desktop
      img_visual_top_mobile
      img_visual_bottom_desktop
      img_visual_bottom_mobile
      detail {
        title
        block_word_title
        block_word_content
        block_video_video
        block_video_title
        block_video_content
        block_video_cta_label
        block_video_cta_url
        block_push_title
        block_push_content
        block_push_cta_label
        block_push_cta_url
        section_instagram_title
        language_code
      }
    }
  }
`;
